import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const NewFolder = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 3.5C2 2.94771 2.44772 2.5 3 2.5H6.27349C6.60305 2.5 6.91145 2.66238 7.09796 2.93409L7.70204 3.81416C7.88855 4.08588 8.19695 4.24825 8.52651 4.24825H13C13.5523 4.24825 14 4.69597 14 5.24825V12.5C14 13.0523 13.5523 13.5 13 13.5H3C2.44772 13.5 2 13.0523 2 12.5L2 3.5Z"
        stroke={color}
        fill="transparent"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 10C12.5 9.72386 12.2761 9.5 12 9.5C11.7239 9.5 11.5 9.72386 11.5 10V11.5H10C9.72386 11.5 9.5 11.7239 9.5 12C9.5 12.2761 9.72386 12.5 10 12.5H11.5V14C11.5 14.2761 11.7239 14.5 12 14.5C12.2761 14.5 12.5 14.2761 12.5 14V12.5H14C14.2761 12.5 14.5 12.2761 14.5 12C14.5 11.7239 14.2761 11.5 14 11.5H12.5V10Z"
      />
      <circle cx="12.5" cy="12.5" r="3.5" fill={color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 10.5C13 10.2239 12.7761 10 12.5 10C12.2239 10 12 10.2239 12 10.5V12H10.5C10.2239 12 10 12.2239 10 12.5C10 12.7761 10.2239 13 10.5 13H12V14.5C12 14.7761 12.2239 15 12.5 15C12.7761 15 13 14.7761 13 14.5V13H14.5C14.7761 13 15 12.7761 15 12.5C15 12.2239 14.7761 12 14.5 12H13V10.5Z"
      />
    </svg>
  )
})

export default NewFolder
